import * as React from "react";
import {useState} from "react";
import TextField from "@mui/material/TextField";
import {Autocomplete} from "@mui/material";
import {useSelector} from "react-redux";
import {State} from "../../reducer";
import Grid from "@mui/material/Grid";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import {Marque} from "../../types";
import IconButton from "@mui/material/IconButton";
import ClearIcon from '@mui/icons-material/Clear';
import CheckIcon from '@mui/icons-material/Check';
import {green} from "@mui/material/colors";

import {
    attachMarqueEditorialeToAdGroup,
    dettachMarqueEditorialeToAdGroup,
    getMarqueEditorialForAdGroup,
    getMarqueEditorialForAdGroupSuccess
} from '../../action/adGroupAction'
import {Fab} from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import { useAppDispatch } from "../../store";

interface Props {
    marqueCollections: Marque[],
    groups: string[]
}

export const MarqueGroupSelection: React.FC<Props> = (props) => {
    const {marqueCollections, groups} = props;

    const marqueForAdGroup = useSelector(({adGroup}: State) => adGroup.marqueEditoriales);

    const [selectedGroup, setSelectedGroup] = useState<string | null>(null);
    const dispatch = useAppDispatch()

    const [isAdded, setAddred] = useState(false);

    return (
        <>
            <Grid
                container style={{marginTop: 37}}
                direction="row"
            >
                <Autocomplete style={{width: 380}}
                    options={groups}
                    getOptionLabel={(option) => option}
                    onChange={(event: any, newValue: string | null) => {
                        if (newValue === null) {
                            dispatch(getMarqueEditorialForAdGroupSuccess([]))
                        } else {
                            dispatch(getMarqueEditorialForAdGroup(newValue))
                        }
                        setSelectedGroup(newValue)
                    }}
                    renderInput={(params) => <TextField {...params} label="Groupe" variant="outlined"/>}
                />

            </Grid>
            <Grid
                container style={{marginTop: 15}}
                direction="row"
            >

                {selectedGroup &&
                <Grid size={12} sx={{scroll: { height: 400, overflowY: 'scroll' }}}>
                    <Table style={{marginTop: 15}}>
                        <TableHead>
                            <TableRow>
                                <TableCell style={{width: 300}}>Marque éditoriale</TableCell>
                                <TableCell align={"center"}>Actions</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            <TableRow>

                                <TableCell>
                                    <Autocomplete
                                                  options={marqueCollections}
                                                  getOptionLabel={(option) => option.label}
                                                  onChange={(event: any, newValue: Marque | null) => {
                                                      if (newValue !== null) {
                                                          dispatch(attachMarqueEditorialeToAdGroup({
                                                              marqueId: newValue.id,
                                                              adGroup: selectedGroup
                                                          }))
                                                          setAddred(true)
                                                      }
                                                  }}

                                                  renderInput={(params) => <TextField {...params} onChange={() => setAddred(false)} label="Ajouter" variant="outlined"/>}
                                    />
                                </TableCell>
                                <TableCell align={"center"}>
                                    {isAdded && <Tooltip title={"La marque a été ajoutée dans le groupe"}>
                                        <Fab size={"small"}
                                             aria-label="save"
                                             style={{
                                                 cursor: "default",
                                                 background: green[500]
                                             }}
                                        >
                                            <CheckIcon/>
                                        </Fab>
                                    </Tooltip>}
                                </TableCell>
                            </TableRow>
                            {marqueForAdGroup.map(x =>
                                <TableRow>

                                    <TableCell>
                                        {x.label}
                                    </TableCell>


                                    <TableCell align={"center"}>
                                        <label htmlFor="icon-button-file">
                                            <IconButton color="primary" aria-label="Détacher" component="span"
                                                        onClick={() => {
                                                            if (selectedGroup !== null)
                                                                dispatch(dettachMarqueEditorialeToAdGroup({
                                                                    marqueId: x.id,
                                                                    adGroup: selectedGroup
                                                                }))
                                                        }}>
                                                <ClearIcon/>
                                            </IconButton>
                                        </label>
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>

                </Grid>
                }

            </Grid>
        </>
    )
}
